import { queryOptions, useQuery } from "@tanstack/react-query";

type EntityListObject = {
  entity_list: Array<string>;
};

const entitiesPlaceholder: EntityListObject = {
  entity_list: [
    "Eye Color",
    "Location",
    "Social Security Number",
    "Crypto",
    "URL",
    "Credit Card",
    "Amount",
    "Phone IMEI",
    "Gender",
    "Driver License",
    "Account Number",
    "Bank Account",
    "Company",
    "Vehicle Identifier",
    "Zipcode",
    "Phone Number",
    "Masked Number",
    "SSN",
    "ID Number",
    "Nationality",
    "Person",
    "Passport",
    "IP",
    "Password",
    "VIN",
    "Height",
    "Date & Time",
    "Measurement Unit",
    "Job Sector",
    "Device Identifier",
    "Date/Time",
    "Bank Account Information",
    "Email",
    "Currency",
    "Title",
    "Job",
    "Username",
    "Address",
  ],
};
async function getEntities() {
  return await Promise.resolve(entitiesPlaceholder);
  // return api.governance
  //   .get<EntityListObject>("gcp/pii/full_entity_list")
  //   .json();
}

export const governanceEntitiesQueryOptions = queryOptions({
  queryKey: ["governance", "entities"],
  queryFn: getEntities,
  select: (data) => data.entity_list,
});

export function useGovernanceEntityList() {
  return useQuery(governanceEntitiesQueryOptions);
}
